import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationRoute } from '../../shared/enums/navigation-route.enum';

@Component({
  selector: 'ya-revoke-order-result',
  templateUrl: './revokeOrderResult.component.html',
  styleUrls: ['./revokeOrderResult.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RevokeOrderResultComponent implements OnInit {

  public outcome: 'success' | 'error';

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) { }

  ngOnInit() {
    const me = this;
    // routeTargetData is injected into snapshot.data by RouterHelperService on NavigationEnd, before this ngOnInit runs.
    const data = me._activatedRoute.snapshot.data['routeTargetData'];
    const outcome = data && data['revokeOutcome'];
    if (outcome !== 'success' && outcome !== 'error') {
      me._router.navigateByUrl(NavigationRoute.Home, { replaceUrl: true });
      return;
    }
    me.outcome = outcome;
  }

  public goHome(): void {
    const me = this;
    me._router.navigate([NavigationRoute.Home], { replaceUrl: true });
  }
}
